import OrganizationAddModal from './OrganizationAddModal';

export default OrganizationAddModal;
